export default __webpack_public_path__ + "static/media/home_2.be50a419.svg";